<template>
  	<FlexAddSinglePin />
</template>

<script>

// @ is an alias to /src
import FlexAddSinglePin from "@/components/Flex/AddSinglePin.vue";

export default {
  name: "FlexAddSinglePins",
  components: {
    FlexAddSinglePin,
  },
};
</script>
